import * as React from 'react';
import { Title } from '../modules';

import { withRouter, RouteComponentProps, Link } from 'react-router-dom';

interface IBlogItemProps extends RouteComponentProps<{ language: string, articleId: string }> {
  id: string;
  type?: string;
  perexImage: string;
  description: string;
  title: string;
  published: string;

  language: string;
  articleId: string;
}

const BlogItem = (props: IBlogItemProps) => {
  const name: string = 'blogItem';
  const { id, description, perexImage, type, published, title } = props;

  return (<div className={name + (type ? ' ' + name + '--' + type : '')}>
        {/* Small */}
        {type === 'sm' ? (
          <div className="blogItem__head">
            <a href="#">
              <img className="blogItem__img" src={perexImage} />
            </a>
            <Title type="md">
              <a href="#">{title}</a>
              <small>{published}</small>
            </Title>
          </div>
        ) : (
          // Default
          <div className="blogItem__head">
            <Title type="main">
              {title}
              <small />
            </Title>
            <img className="blogItem__img" src={perexImage} />
          </div>
        )}

        {type !== 'sm' && (
          <div className="blogItem__content">
            <div className="blogItem__text" dangerouslySetInnerHTML={{ __html: description }} />
            <div className="blogItem__buttons">
              <Link to={`/${props.language}/blog/${id}`} className="btn btn--readMore">
                Přečíst celé
              </Link>
            </div>
          </div>
        )}
      </div>);
};

export default withRouter(BlogItem);



// WEBPACK FOOTER //
// ./src/modules/BlogItem/BlogItem.tsx